import React, { Component } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import moment from 'moment';
import CBMediaQuery from '../../shared/CBMediaQuery';
import '../../../App.css';
import { getStyle, SERVICE_FLEET, SERVICE_WORKSHOP, SERVICE_CHAIN } from '../../../utils/utils';
import CBInputField from '../../shared/form_components/CBInputField';
import CBTextAreaField from '../../shared/form_components/CBTextAreaField';
import CBSelectField from '../../shared/form_components/CBSelectField';
import CBModal from '../../shared/CBModal';
import CBDropzone from '../../shared/CBDropzone';
import ImagePreview from '../../shared/ImagePreview';
import CBLabelAndCheckbox from '../../shared/CBLabelAndCheckbox';
import RadioButtonGroup from '../../shared/RadioButtonGroup';
import { MultiSelect } from 'primereact/multiselect';
import { ListBox } from 'primereact/listbox';
import axios from 'axios';
import {
  ROLE_ASSIGNED_VEHICLE_MANAGER,
  getMessagingRoleLabel,
  getOrganizationRecipientRoleOptions,
  getWorkshopRecipientRoleOptions,
  stripAssignedVehicleManager,
} from '../../../utils/messagingRoles';
import {
  createChainMessage as _createChainMessage,
  createCSChainMessage as _createCSChainMessage,
  createChainVehicleMessage as _createChainVehicleMessage,
  getAudienceUrl,
} from '../../../actions/messageActions';
import {
  fetchChainMemberships as _fetchChainMemberships,
  fetchChainCareServices as _fetchChainCareServices,
} from '../../../actions/chainActions';
import {
  getLengthValidator,
} from '../../../utils/validators';


// Message types whose recipient is fixed: they always go to ketjujohto and the
// sender is not offered a choice.
const ALWAYS_TO_CHAIN_TYPES = ['approval_request', 'availability_inquiry', 'customer_approval'];

// Portals that get the live "Kuka näkee viestin" list in the send dialog.
// Restricting it later is a one-line change here.
const AUDIENCE_PORTALS = [SERVICE_CHAIN, SERVICE_FLEET, SERVICE_WORKSHOP];
const AUDIENCE_DEBOUNCE_MS = 400;


class CreateChainMessageModal extends Component {
  constructor(props) {
    super(props);

    const { presetMessageType, presetReservations } = props;
    const service = props.service || props.appService;
    const isFleetPortal = service === SERVICE_FLEET;
    const isWorkshopPortal = service === SERVICE_WORKSHOP;
    const defaultMessageType = (isFleetPortal || isWorkshopPortal) ? 'vehicle' : 'chain_message';

    // Extract vehicle_ids and reservation_ids from preset reservations
    let presetVehicleIds = [];
    let presetReservationIds = [];
    let presetRecipientWorkshops = [];
    let presetRecipientOrganizations = [];
    const organizationNames = {};
    if (presetReservations && presetReservations.length > 0) {
      presetReservationIds = presetReservations.map((r) => r.id);
      const vehicleIdSet = {};
      const workshopIdSet = {};
      const organizationIdSet = {};
      presetReservations.forEach((r) => {
        if (r.vehicle && !vehicleIdSet[r.vehicle]) {
          vehicleIdSet[r.vehicle] = true;
        }
        if (r.workshop && !workshopIdSet[r.workshop]) {
          workshopIdSet[r.workshop] = true;
        }
        if (r.organization_id && !organizationIdSet[r.organization_id]) {
          organizationIdSet[r.organization_id] = true;
        }
        if (r.organization_id && r.organization_name) {
          organizationNames[r.organization_id] = r.organization_name;
        }
      });
      presetVehicleIds = Object.keys(vehicleIdSet).map(Number);
      presetRecipientWorkshops = Object.keys(workshopIdSet).map(Number);
      presetRecipientOrganizations = Object.keys(organizationIdSet).map(Number);
    }

    // A workshop sending from the service portal is the sender, not a recipient:
    // never address a request back to the sending workshop itself (that listed it
    // under "Vastaanottajat" and mailed its own colleagues about their request).
    const { selectedWorkshopId } = props;
    if (isWorkshopPortal && selectedWorkshopId) {
      presetRecipientWorkshops = presetRecipientWorkshops.filter(function (id) {
        return id !== Number(selectedWorkshopId);
      });
    }

    // Customer-approval requests are addressed to the booking's fleet customer (and the
    // chain); the organization is derived from the booking, not picked by the workshop.
    const isCustomerApproval = presetMessageType === 'customer_approval';

    // Lupapyyntö asiakkaalle goes, by default, to the ajoneuvovastaava of the
    // booking's vehicle (decision 2026-09-01). The sender may widen it in the
    // dialog; the audience list below says exactly who that reaches.
    const initialRecipientRoles = {};
    if (isCustomerApproval && presetRecipientOrganizations.length) {
      initialRecipientRoles.organizations = {};
      presetRecipientOrganizations.forEach((orgId) => {
        initialRecipientRoles.organizations[String(orgId)] = ROLE_ASSIGNED_VEHICLE_MANAGER;
      });
    }

    // Where the message goes inside the chain. '' = nowhere in particular,
    // 'chain' = ketjujohto, 'broadcast' = ketjujohto + every member workshop.
    // Approval requests and availability inquiries always address ketjujohto.
    // Everyone else defaults to ketjujohto EXCEPT the chain portal itself, where
    // broadcasting to every workshop has to be a deliberate choice.
    const initialType = presetMessageType || defaultMessageType;
    const alwaysToChain = ALWAYS_TO_CHAIN_TYPES.indexOf(initialType) !== -1;
    let initialChainAudience = '';
    if (alwaysToChain || isFleetPortal || isWorkshopPortal) {
      initialChainAudience = 'chain';
    }

    this.state = {
      formData: {
        subject: '',
        text: '',
        message_type: initialType,
        recipient_workshops: presetRecipientWorkshops,
        recipient_organizations: isCustomerApproval ? presetRecipientOrganizations : [],
        chain_audience: initialChainAudience,
        image_actions: [],
        vehicle_ids: presetVehicleIds,
        reservation_ids: presetReservationIds,
        create_task: false,
        recipient_roles: initialRecipientRoles,
      },
      formValid: {
        subject: false,
        text: false,
      },
      modalChainId: null,
      presetOrganizationNames: organizationNames,
      audience: null,
      audienceLoading: false,
      audienceError: false,
      audienceExpanded: true,
    };
    // Audience preview bookkeeping (not state: changing it must not re-render).
    this.audienceSeq = 0;
    this.audienceTimer = null;
    this.lastAudienceKey = null;
    this.isUnmounted = false;
  }

  // CSUpcomingMaintenancesView opens this dialog without a `service` prop.
  getEffectiveService = () => this.props.service || this.props.appService;

  getWorkshopChains = () => {
    var { user, selectedWorkshopId } = this.props;
    if (!user || !user.workshops || !selectedWorkshopId) return [];
    var ws = user.workshops.find(function (w) { return w.id == selectedWorkshopId; });
    return (ws && ws.workshop_chains) ? ws.workshop_chains : [];
  };

  getResolvedChainId = () => {
    var { chainId, selectedChainId } = this.props;
    if (chainId) return chainId;
    if (selectedChainId) return selectedChainId;
    return this.state.modalChainId;
  };

  onModalChainChange = (changedObject) => {
    if (!changedObject.value) {
      this.setState({ modalChainId: null });
      return;
    }
    var newChainId = parseInt(changedObject.value, 10);
    if (isNaN(newChainId)) return;
    var { fetchChainMemberships, fetchChainCareServices } = this.props;
    this.setState({ modalChainId: newChainId }, function () {
      fetchChainMemberships(newChainId);
      fetchChainCareServices(newChainId);
    });
  };

  componentDidMount() {
    var { fetchChainMemberships, fetchChainCareServices } = this.props;
    var effectiveChainId = this.getResolvedChainId();
    if (effectiveChainId) {
      fetchChainMemberships(effectiveChainId);
      fetchChainCareServices(effectiveChainId);
    }
    this.syncAudience();
  }

  componentDidUpdate() {
    this.syncAudience();
  }

  componentWillUnmount() {
    this.isUnmounted = true;
    clearTimeout(this.audienceTimer);
  }

  // ---- "Kuka näkee viestin" -------------------------------------------------
  // Re-fetched (debounced) whenever the recipient selection or the linked
  // vehicles change. A plain axios call rather than the Redux API middleware:
  // the middleware toasts "Tiedot tallennettiin" on every non-GET and its
  // .then() carries no payload.

  getAudienceBody = () => {
    const { formData } = this.state;
    return {
      message_type: formData.message_type,
      recipient_workshops: formData.recipient_workshops,
      recipient_organizations: formData.recipient_organizations,
      chain_audience: formData.chain_audience,
      recipient_roles: formData.recipient_roles,
      vehicle_ids: formData.vehicle_ids,
      reservation_ids: formData.reservation_ids,
    };
  };

  shouldFetchAudience = () => {
    const { formData } = this.state;
    return AUDIENCE_PORTALS.indexOf(this.getEffectiveService()) !== -1
      && formData.message_type !== 'vehicle'
      && !!this.getResolvedChainId();
  };

  syncAudience = () => {
    if (!this.shouldFetchAudience()) return;
    const key = JSON.stringify(this.getAudienceBody()) + '|' + this.getResolvedChainId();
    if (key === this.lastAudienceKey) return;
    this.lastAudienceKey = key;
    clearTimeout(this.audienceTimer);
    this.audienceTimer = setTimeout(this.fetchAudience, AUDIENCE_DEBOUNCE_MS);
  };

  fetchAudience = () => {
    const { selectedWorkshopId, selectedOrganizationId } = this.props;
    this.audienceSeq += 1;
    const seq = this.audienceSeq;
    const organizationId = this.getEffectiveService() === SERVICE_FLEET ? selectedOrganizationId : null;
    const url = getAudienceUrl(selectedWorkshopId, this.getResolvedChainId(), organizationId);
    this.setState({ audienceLoading: true, audienceError: false });
    axios.post(url, this.getAudienceBody())
      .then((response) => {
        // A newer selection is already in flight: drop this stale answer.
        if (this.isUnmounted || seq !== this.audienceSeq) return;
        this.setState({ audience: response.data, audienceLoading: false });
      })
      .catch(() => {
        if (this.isUnmounted || seq !== this.audienceSeq) return;
        this.setState({ audienceError: true, audienceLoading: false });
      });
  };

  getAudienceGroupTitle = (group) => {
    const { t } = this.props;
    if (group.type === 'chain_staff') {
      return t('audienceAlwaysSees') + ': ' + group.name;
    }
    if (group.type === 'chain_broadcast_workshop') {
      return group.name + ' — ' + t('audienceBroadcastWorkshop');
    }
    if (group.type === 'sender_workshop' || group.type === 'sender_organization') {
      return group.name + ' — ' + t('audienceSenderEntity');
    }
    return group.name + (group.role ? (' — ' + getMessagingRoleLabel(t, group.role)) : '');
  };

  renderAudienceGroup = (group, screenSize) => {
    const { t } = this.props;
    return (
      <div key={group.type + '-' + group.id} style={getStyle(screenSize, styles, 'audienceGroup')}>
        <div style={getStyle(screenSize, styles, 'audienceGroupTitle')}>
          {this.getAudienceGroupTitle(group)} ({group.users.length})
        </div>
        <div style={getStyle(screenSize, styles, 'audienceUsers')}>
          {group.users.length ? group.users.map((u) => u.name).join(', ') : t('audienceNobody')}
        </div>
      </div>
    );
  };

  renderAudienceWarning = (warning, screenSize) => {
    const { t } = this.props;
    const registrationNumber = warning.registration_number || ('#' + warning.vehicle_id);
    let text;
    if (warning.code === 'no_assigned_vehicle_manager') {
      text = t('audienceWarningNoVehicleManager', { registrationNumber });
    } else if (warning.code === 'vehicle_not_in_organization') {
      text = t('audienceWarningVehicleNotInOrganization', { registrationNumber });
    } else {
      text = t('audienceWarningGeneric', { code: warning.code });
    }
    return (
      <div key={warning.code + '-' + warning.vehicle_id} style={getStyle(screenSize, styles, 'audienceWarning')}>
        {text}
      </div>
    );
  };

  renderAudienceWidget = (screenSize) => {
    const { t } = this.props;
    const {
      audience, audienceLoading, audienceError, audienceExpanded,
    } = this.state;
    if (!this.shouldFetchAudience()) {
      return this.renderVisibilitySummary(screenSize);
    }
    const groups = audience ? audience.groups : [];
    const alwaysSees = audience && audience.always_sees && audience.always_sees.users.length
      ? audience.always_sees : null;
    const warnings = audience ? audience.warnings : [];
    const seen = {};
    let count = 0;
    groups.concat(alwaysSees ? [alwaysSees] : []).forEach((group) => {
      group.users.forEach((u) => {
        if (!seen[u.id]) {
          seen[u.id] = true;
          count += 1;
        }
      });
    });
    let countText = '';
    if (audienceLoading) {
      countText = t('audienceLoading');
    } else if (audience) {
      countText = t('audiencePeopleCount', { count });
    }
    return (
      <div style={getStyle(screenSize, styles, 'summaryContainer')}>
        <div style={getStyle(screenSize, styles, 'audienceHeader')}>
          <span style={getStyle(screenSize, styles, 'summaryLabel')}>{t('audienceTitle')}</span>
          <span style={getStyle(screenSize, styles, 'audienceCount')}>{countText}</span>
          <button
            type='button'
            style={getStyle(screenSize, styles, 'audienceToggle')}
            onClick={() => this.setState({ audienceExpanded: !audienceExpanded })}
          >
            {audienceExpanded ? t('audienceHide') : t('audienceShow')}
          </button>
        </div>
        {audienceError && (
          <p style={getStyle(screenSize, styles, 'summaryText')}>{t('audienceError')}</p>
        )}
        {warnings.map((warning) => this.renderAudienceWarning(warning, screenSize))}
        {audienceExpanded && audience && (
          <div>
            {groups.map((group) => this.renderAudienceGroup(group, screenSize))}
            {alwaysSees && this.renderAudienceGroup(alwaysSees, screenSize)}
          </div>
        )}
      </div>
    );
  };

  setIsValid = (name, isValid) => {
    const { formValid } = this.state;
    const newFormValid = {
      ...formValid,
      [name]: isValid,
    };
    this.setState({ formValid: newFormValid });
  };

  updateFormState = (changedObject) => {
    const { formData } = this.state;
    const updates = { [changedObject.target]: changedObject.value };
    // Approval requests and availability inquiries always go to ketjujohto only —
    // clear every other recipient so the summary cannot claim otherwise.
    if (changedObject.target === 'message_type'
        && ALWAYS_TO_CHAIN_TYPES.indexOf(changedObject.value) !== -1) {
      updates.chain_audience = 'chain';
      updates.recipient_workshops = [];
      updates.recipient_organizations = [];
    }
    // "The vehicle's ajoneuvovastaava" only means something while vehicles are linked.
    if (changedObject.target === 'vehicle_ids' && !(changedObject.value && changedObject.value.length)
        && !formData.reservation_ids.length) {
      updates.recipient_roles = stripAssignedVehicleManager(formData.recipient_roles);
    }
    this.setState({
      formData: {
        ...formData,
        ...updates,
      },
    });
  };

  handleRecipientsChange = (field, value) => {
    const { formData } = this.state;
    // Clean up recipient_roles for removed recipients
    const newRecipientRoles = Object.assign({}, formData.recipient_roles);
    const entityType = field === 'recipient_workshops' ? 'workshops' : 'organizations';
    if (newRecipientRoles[entityType]) {
      const updatedRoles = {};
      Object.keys(newRecipientRoles[entityType]).forEach(function (key) {
        if (value.includes(Number(key))) {
          updatedRoles[key] = newRecipientRoles[entityType][key];
        }
      });
      newRecipientRoles[entityType] = updatedRoles;
    }
    this.setState({
      formData: {
        ...formData,
        [field]: value,
        recipient_roles: newRecipientRoles,
      },
    });
  };

  handleRecipientRoleChange = (entityType, entityId, role) => {
    const { formData } = this.state;
    const newRecipientRoles = Object.assign({}, formData.recipient_roles);
    if (!newRecipientRoles[entityType]) {
      newRecipientRoles[entityType] = {};
    }
    if (role) {
      newRecipientRoles[entityType][String(entityId)] = role;
    } else {
      delete newRecipientRoles[entityType][String(entityId)];
    }
    this.setState({
      formData: {
        ...formData,
        recipient_roles: newRecipientRoles,
      },
    });
  };

  onDropImage = (acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageChanged(reader.result, file);
      };
    });
  };

  imageChanged = (image, file) => {
    const { formData } = this.state;
    const newFormData = Object.assign({}, formData);
    newFormData.image_actions.push({
      action: 'create',
      data: image,
      preview: file.preview,
    });
    this.setState({ formData: newFormData });
  };

  deleteImage = (image) => {
    const { formData } = this.state;
    const newImageActions = formData.image_actions.filter(
      (img) => img.preview !== image.preview,
    );
    this.setState({
      formData: {
        ...formData,
        image_actions: newImageActions,
      },
    });
  };

  submitForm = () => {
    const {
      createChainMessage, createCSChainMessage, createChainVehicleMessage,
      closeModal, selectedWorkshopId,
    } = this.props;
    const { formData } = this.state;
    const effectiveChainId = this.getResolvedChainId();

    if (formData.message_type === 'vehicle') {
      createChainVehicleMessage(formData, effectiveChainId).then(() => {
        closeModal();
      });
    } else if (selectedWorkshopId) {
      // Service portal: a member-workshop user creates chain-context messages through
      // cs_message, which permits workshop members of the chain. (cc_message requires a
      // chain-level permission these users do not have.)
      createCSChainMessage(formData, selectedWorkshopId, effectiveChainId).then(() => {
        closeModal();
      });
    } else {
      createChainMessage(formData, effectiveChainId).then(() => {
        closeModal();
      });
    }
  };

  getIsValid = () => {
    const { formValid, formData } = this.state;
    let isValid = true;
    Object.values(formValid).forEach((fieldIsValid) => {
      if (!fieldIsValid) {
        isValid = false;
      }
    });
    if (formData.message_type === 'vehicle' && !formData.vehicle_ids.length) {
      isValid = false;
    }
    if (!this.getResolvedChainId()) {
      isValid = false;
    }
    const orgRoles = formData.recipient_roles && formData.recipient_roles.organizations;
    if (orgRoles && !formData.vehicle_ids.length && !formData.reservation_ids.length) {
      Object.keys(orgRoles).forEach((key) => {
        if (orgRoles[key] === ROLE_ASSIGNED_VEHICLE_MANAGER) {
          isValid = false;
        }
      });
    }
    return isValid;
  };

  getWorkshopOptions = () => {
    const { chainMemberships } = this.props;
    if (!chainMemberships) return [];
    return chainMemberships.map((m) => ({
      label: m.workshop ? m.workshop.name : ('Korjaamo #' + m.workshop_id),
      value: m.workshop ? m.workshop.id : m.workshop_id,
    }));
  };

  getOrganizationOptions = () => {
    const { chainCareServices } = this.props;
    if (!chainCareServices) return [];
    const seen = {};
    return chainCareServices
      .filter((cs) => cs.organization && !seen[cs.organization] && (seen[cs.organization] = true))
      .map((cs) => ({
        label: cs.organization_name || ('Yritys #' + cs.organization),
        value: cs.organization,
      }));
  };

  // Spells out, in the send dialog, exactly who ends up able to open the message.
  // Ketjujohto is always listed: chain management can read every message in its own
  // chain regardless of who it was addressed to, so leaving it out would be a lie.
  getVisibilityAudience = () => {
    const { t } = this.props;
    const { formData } = this.state;
    const parts = [];

    if (formData.chain_audience === 'broadcast') {
      parts.push(t('summaryAllWorkshops'));
    } else if (formData.recipient_workshops.length) {
      const options = this.getWorkshopOptions();
      formData.recipient_workshops.forEach(function (id) {
        const match = options.find(function (o) { return o.value === id; });
        parts.push(match ? match.label : ('#' + id));
      });
    }

    if (formData.recipient_organizations.length) {
      const orgOptions = this.getOrganizationOptions();
      formData.recipient_organizations.forEach(function (id) {
        const match = orgOptions.find(function (o) { return o.value === id; });
        parts.push(match ? match.label : ('#' + id));
      });
    }

    parts.push(t('summaryChainManagement'));
    return parts;
  };

  renderVisibilitySummary = (screenSize) => {
    const { t } = this.props;
    return (
      <div style={getStyle(screenSize, styles, 'summaryContainer')}>
        <p style={getStyle(screenSize, styles, 'summaryText')}>
          <span style={getStyle(screenSize, styles, 'summaryLabel')}>{t('summaryLabel')}</span>
          {' '}
          {this.getVisibilityAudience().join(' · ')}
        </p>
      </div>
    );
  };

  getVehicleOptions = () => {
    const { chainCareServiceVehicles, vehicles } = this.props;
    // Use passed vehicles prop (from MessageListView) if available, fall back to chain care service vehicles
    const vehicleList = vehicles || chainCareServiceVehicles;
    if (!vehicleList) return [];
    return vehicleList.map((v) => ({
      id: v.vehicle || v.vehicle_id || v.id,
      display_label: [v.registration_number, v.manufacturer, v.model_name || v.model].filter(Boolean).join(' - '),
    }));
  };

  render() {
    const {
      modalIsOpen, closeModal, t, presetMessageType, presetReservations, chainId, selectedChainId,
    } = this.props;
    const { formData, modalChainId, presetOrganizationNames } = this.state;
    const service = this.getEffectiveService();
    var workshopChains = this.getWorkshopChains();
    var needsChainSelector = !chainId && !selectedChainId && workshopChains.length > 1;
    var chainOptions = [{ label: t('selectChainPlaceholder'), value: '' }].concat(
      workshopChains.map(function (c) { return { label: c.name, value: String(c.id) }; })
    );

    const isVehicleMessage = formData.message_type === 'vehicle';
    const isApprovalRequest = formData.message_type === 'approval_request';
    const isAvailabilityInquiry = formData.message_type === 'availability_inquiry';
    const isCustomerApproval = formData.message_type === 'customer_approval';
    const hasPresetReservations = presetReservations && presetReservations.length > 0;
    const isFleet = service === SERVICE_FLEET;
    const isWorkshop = service === SERVICE_WORKSHOP;
    const isChainPortal = service === SERVICE_CHAIN || (!isFleet && !isWorkshop);
    const newImages = formData.image_actions.filter((ia) => ia.action === 'create');
    const showVehicleSelector = isVehicleMessage || ((isApprovalRequest || isAvailabilityInquiry || isCustomerApproval) && !hasPresetReservations);
    // A plain chain message may optionally be about vehicles — that is what makes
    // "the vehicle's ajoneuvovastaava" available as its recipient.
    const showOptionalVehicleSelector = formData.message_type === 'chain_message' && !hasPresetReservations;
    const vehicleOptions = (showVehicleSelector || showOptionalVehicleSelector) ? this.getVehicleOptions() : [];
    const hasLinkedVehicles = formData.vehicle_ids.length > 0 || formData.reservation_ids.length > 0;

    const messageTypeOptions = [];
    // Fleet portal: vehicle message first (default), then chain message
    // Chain portal: chain message first (default), then vehicle message
    // Service portal: vehicle message first, then chain message, approval, availability
    if (isFleet) {
      messageTypeOptions.push({ label: t('vehicleMessage'), value: 'vehicle' });
      messageTypeOptions.push({ label: t('chainMessage'), value: 'chain_message' });
    } else if (isWorkshop) {
      messageTypeOptions.push({ label: t('vehicleMessage'), value: 'vehicle' });
      messageTypeOptions.push({ label: t('chainMessage'), value: 'chain_message' });
      messageTypeOptions.push({ label: t('approvalRequest'), value: 'approval_request' });
      messageTypeOptions.push({ label: t('availabilityInquiry'), value: 'availability_inquiry' });
    } else {
      // Chain portal
      messageTypeOptions.push({ label: t('chainMessage'), value: 'chain_message' });
      messageTypeOptions.push({ label: t('vehicleMessage'), value: 'vehicle' });
    }
    // Approval requests and availability inquiries also when preset from upcoming maintenances
    if (presetMessageType === 'approval_request' && !messageTypeOptions.find((o) => o.value === 'approval_request')) {
      messageTypeOptions.push({ label: t('approvalRequest'), value: 'approval_request' });
    }
    if (presetMessageType === 'availability_inquiry' && !messageTypeOptions.find((o) => o.value === 'availability_inquiry')) {
      messageTypeOptions.push({ label: t('availabilityInquiry'), value: 'availability_inquiry' });
    }
    if (presetMessageType === 'customer_approval' && !messageTypeOptions.find((o) => o.value === 'customer_approval')) {
      messageTypeOptions.push({ label: t('customerApprovalRequest'), value: 'customer_approval' });
    }

    const title = isCustomerApproval
      ? t('customerApprovalRequest')
      : (isVehicleMessage ? t('createVehicleMessageTitle') : t('createChainMessageTitle'));

    return (
      <CBMediaQuery>
        {screenSize => (
          <CBModal
            modalIsOpen={modalIsOpen}
            closeModal={closeModal}
            title={title}
            isValid={this.getIsValid()}
            submitForm={this.submitForm}
            submitText={t('sendMessage')}
            cancelText='Peruuta'
          >
            <div style={getStyle(screenSize, styles, 'bodyContainer')}>
              <div style={getStyle(screenSize, styles, 'formComponentContainer')}>
                <CBSelectField
                  name='message_type'
                  value={formData.message_type}
                  options={messageTypeOptions}
                  onChange={this.updateFormState}
                  labelText={t('messageType')}
                  labelTextStyle={getStyle(screenSize, styles, 'inputLabelText')}
                  inputStyle={getStyle(screenSize, styles, 'select')}
                  disabled={!!presetMessageType}
                />
              </div>

              {hasPresetReservations && (
                <div style={getStyle(screenSize, styles, 'formComponentContainer')}>
                  <p
                    className='font-titillium-web-semi-bold'
                    style={getStyle(screenSize, styles, 'inputLabelText')}
                  >
                    {t('linkedVehicles')} ({presetReservations.length})
                  </p>
                  <div style={{ maxHeight: 200, overflowY: 'auto', border: '1px solid #ddd', borderRadius: 4, padding: 8 }}>
                    {presetReservations.map((r) => (
                      <div key={r.id} style={{ padding: '4px 0', borderBottom: '1px solid #eee', fontSize: 13 }}>
                        <strong>{r.reg_nr}</strong>
                        {r.workshop_name ? (' - ' + r.workshop_name) : ''}
                        {r.start ? (' - ' + moment(r.start).format('DD.MM.YYYY HH:mm')) : ''}
                        {r.description ? (' - ' + r.description) : ''}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {(showVehicleSelector || (showOptionalVehicleSelector && vehicleOptions.length > 0)) && !hasPresetReservations && (
                <div style={getStyle(screenSize, styles, 'formComponentContainer')}>
                  <p
                    className='font-titillium-web-semi-bold'
                    style={getStyle(screenSize, styles, 'inputLabelText')}
                  >
                    {showVehicleSelector ? t('selectVehicles') : t('linkedVehiclesOptional')}
                  </p>
                  <ListBox
                    filter
                    filterBy='display_label'
                    filterPlaceholder={t('searchVehicles')}
                    multiple
                    value={vehicleOptions.filter((v) => formData.vehicle_ids.includes(v.id))}
                    onChange={(e) => {
                      this.updateFormState({
                        target: 'vehicle_ids',
                        value: e.value.map((val) => val.id),
                      });
                    }}
                    options={vehicleOptions}
                    optionLabel='display_label'
                    className='w-full md:w-14rem'
                    listStyle={{ maxHeight: '250px' }}
                  />
                </div>
              )}

              <div style={getStyle(screenSize, styles, 'formComponentContainer')}>
                <CBInputField
                  name='subject'
                  value={formData.subject}
                  placeholder=''
                  onChange={this.updateFormState}
                  validators={[getLengthValidator(1, 255)]}
                  isValidCallback={this.setIsValid}
                  labelText={t('subject')}
                  labelTextStyle={getStyle(screenSize, styles, 'inputLabelText')}
                  inputStyle={getStyle(screenSize, styles, 'input')}
                />
              </div>

              <div style={getStyle(screenSize, styles, 'formComponentContainer')}>
                <CBTextAreaField
                  name='text'
                  value={formData.text}
                  onChange={this.updateFormState}
                  labelText={t('messageText')}
                  labelTextStyle={getStyle(screenSize, styles, 'inputLabelText')}
                  validators={[getLengthValidator(1, 10000)]}
                  isValidCallback={this.setIsValid}
                  validateOnInput
                />
              </div>

              {!isVehicleMessage && needsChainSelector && (
                <div style={getStyle(screenSize, styles, 'formComponentContainer')}>
                  <CBSelectField
                    name='modal_chain_id'
                    value={modalChainId ? String(modalChainId) : ''}
                    options={chainOptions}
                    onChange={this.onModalChainChange}
                    labelText={t('selectChain')}
                    labelTextStyle={getStyle(screenSize, styles, 'inputLabelText')}
                    inputStyle={getStyle(screenSize, styles, 'select')}
                  />
                </div>
              )}

              {!isVehicleMessage && !isApprovalRequest && !isAvailabilityInquiry && !isCustomerApproval && (
                <div>
                  {(isChainPortal || isFleet) && (
                    <div style={getStyle(screenSize, styles, 'formComponentContainer')}>
                      <p
                        className='font-titillium-web-semi-bold'
                        style={getStyle(screenSize, styles, 'inputLabelText')}
                      >
                        {t('recipientWorkshops')}
                      </p>
                      <MultiSelect
                        value={formData.recipient_workshops}
                        options={this.getWorkshopOptions()}
                        onChange={(e) => this.handleRecipientsChange('recipient_workshops', e.value)}
                        placeholder={t('selectWorkshops')}
                        style={{ width: '100%' }}
                        panelHeaderTemplate={(options) => (
                          <div className={options.className}>
                            {options.checkboxElement}
                            <span
                              style={{ flex: 1, marginLeft: 4, fontSize: 13, color: '#666', cursor: 'pointer' }}
                              onClick={options.onChange}
                            >
                              {t('sendToAllWorkshops')}
                            </span>
                            {options.closeElement}
                          </div>
                        )}
                      />
                      {formData.recipient_workshops.length > 0 && (
                        <div style={getStyle(screenSize, styles, 'roleNarrowingContainer')}>
                          {formData.recipient_workshops.map((wsId) => {
                            const wsOption = this.getWorkshopOptions().find((o) => o.value === wsId);
                            const wsRoles = formData.recipient_roles && formData.recipient_roles.workshops;
                            const currentRole = wsRoles && wsRoles[String(wsId)] ? wsRoles[String(wsId)] : '';
                            return (
                              <div key={wsId} style={getStyle(screenSize, styles, 'roleNarrowingRow')}>
                                <span style={getStyle(screenSize, styles, 'roleNarrowingLabel')}>
                                  {wsOption ? wsOption.label : wsId}
                                </span>
                                <CBSelectField
                                  value={currentRole}
                                  options={getWorkshopRecipientRoleOptions(t)}
                                  onChange={(opt) => this.handleRecipientRoleChange('workshops', wsId, opt.value)}
                                  inputStyle={getStyle(screenSize, styles, 'roleNarrowingSelect')}
                                  containerStyle={{ margin: 0 }}
                                />
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  )}

                  {/* Chain portal only: a workshop's ketjuviesti goes to ketjujohto,
                      never straight to a customer company (Jari, 2.9.2026). */}
                  {isChainPortal && (
                    <div style={getStyle(screenSize, styles, 'formComponentContainer')}>
                      <p
                        className='font-titillium-web-semi-bold'
                        style={getStyle(screenSize, styles, 'inputLabelText')}
                      >
                        {t('recipientOrganizations')}
                      </p>
                      <MultiSelect
                        value={formData.recipient_organizations}
                        options={this.getOrganizationOptions()}
                        onChange={(e) => this.handleRecipientsChange('recipient_organizations', e.value)}
                        placeholder={t('selectOrganizations')}
                        style={{ width: '100%' }}
                      />
                      {formData.recipient_organizations.length > 0 && (
                        <div style={getStyle(screenSize, styles, 'roleNarrowingContainer')}>
                          {formData.recipient_organizations.map((orgId) => {
                            const orgOption = this.getOrganizationOptions().find((o) => o.value === orgId);
                            const orgRoles = formData.recipient_roles && formData.recipient_roles.organizations;
                            const currentRole = orgRoles && orgRoles[String(orgId)] ? orgRoles[String(orgId)] : '';
                            return (
                              <div key={orgId} style={getStyle(screenSize, styles, 'roleNarrowingRow')}>
                                <span style={getStyle(screenSize, styles, 'roleNarrowingLabel')}>
                                  {orgOption ? orgOption.label : orgId}
                                </span>
                                <CBSelectField
                                  value={currentRole}
                                  options={getOrganizationRecipientRoleOptions(t, hasLinkedVehicles)}
                                  onChange={(opt) => this.handleRecipientRoleChange('organizations', orgId, opt.value)}
                                  inputStyle={getStyle(screenSize, styles, 'roleNarrowingSelect')}
                                  containerStyle={{ margin: 0 }}
                                />
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  )}

                  {isWorkshop && (
                    <div style={getStyle(screenSize, styles, 'formComponentContainer')}>
                      {/* All three choices visible at once — as a dropdown the
                          "whole chain" option went unnoticed (client feedback). */}
                      {/* "Ei lähetetä ketjulle" removed (client decision,
                          4.9.2026): a workshop's chain message always reaches
                          at least ketjujohto. The backend floors this too. */}
                      <RadioButtonGroup
                        name='chain_audience'
                        title={t('audienceLabel')}
                        options={[
                          { label: t('audienceChainManagement'), value: 'chain' },
                          { label: t('audienceBroadcast'), value: 'broadcast' },
                        ]}
                        value={formData.chain_audience || 'chain'}
                        setValue={(value) => this.updateFormState({
                          target: 'chain_audience',
                          value: value,
                        })}
                      />
                    </div>
                  )}

                  {isFleet && (
                    <CBLabelAndCheckbox
                      color='blue'
                      checked={formData.chain_audience === 'chain'}
                      labelText={t('sendToChainManagement')}
                      onChange={() => this.updateFormState({
                        target: 'chain_audience',
                        value: formData.chain_audience === 'chain' ? '' : 'chain',
                      })}
                      additionalStyles={{ marginBottom: 16 }}
                    />
                  )}

                  {isChainPortal && (
                    <CBLabelAndCheckbox
                      color='blue'
                      checked={formData.chain_audience === 'broadcast'}
                      labelText={t('showToAllWorkshops')}
                      onChange={() => this.updateFormState({
                        target: 'chain_audience',
                        value: formData.chain_audience === 'broadcast' ? '' : 'broadcast',
                      })}
                      additionalStyles={{ marginBottom: 16 }}
                    />
                  )}

                  {this.renderAudienceWidget(screenSize)}
                </div>
              )}

              {isCustomerApproval && (
                <div style={getStyle(screenSize, styles, 'formComponentContainer')}>
                  <p
                    className='font-titillium-web-semi-bold'
                    style={getStyle(screenSize, styles, 'inputLabelText')}
                  >
                    {t('recipientOrganizations')}
                  </p>
                  {/* The customer comes from the booking; only how far inside the
                      company the request goes is the workshop's choice. */}
                  <div style={getStyle(screenSize, styles, 'roleNarrowingContainer')}>
                    {formData.recipient_organizations.map((orgId) => {
                      const orgOption = this.getOrganizationOptions().find((o) => o.value === orgId);
                      const orgRoles = formData.recipient_roles && formData.recipient_roles.organizations;
                      const currentRole = orgRoles && orgRoles[String(orgId)] ? orgRoles[String(orgId)] : '';
                      let label = '#' + orgId;
                      if (orgOption) {
                        label = orgOption.label;
                      } else if (presetOrganizationNames[orgId]) {
                        label = presetOrganizationNames[orgId];
                      }
                      return (
                        <div key={orgId} style={getStyle(screenSize, styles, 'roleNarrowingRow')}>
                          <span style={getStyle(screenSize, styles, 'roleNarrowingLabel')}>{label}</span>
                          <CBSelectField
                            value={currentRole}
                            options={getOrganizationRecipientRoleOptions(t, hasLinkedVehicles)}
                            onChange={(opt) => this.handleRecipientRoleChange('organizations', orgId, opt.value)}
                            inputStyle={getStyle(screenSize, styles, 'roleNarrowingSelect')}
                            containerStyle={{ margin: 0 }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {(isApprovalRequest || isAvailabilityInquiry || isCustomerApproval) && (
                <div style={getStyle(screenSize, styles, 'formComponentContainer')}>
                  <p
                    className='font-titillium-web-semi-bold'
                    style={getStyle(screenSize, styles, 'inputLabelText')}
                  >
                    {t('recipient')}
                  </p>
                  <p style={{ fontSize: 14, color: '#333', padding: '8px 0' }}>
                    {isCustomerApproval
                      ? t('customerApprovalRecipient')
                      : (isAvailabilityInquiry ? t('availabilityInquiryRecipientChain') : t('approvalRequestRecipientChain'))}
                  </p>
                  {this.renderAudienceWidget(screenSize)}
                </div>
              )}

              <div style={getStyle(screenSize, styles, 'dropZoneContainer')}>
                <CBDropzone
                  className='opacity-on-hover'
                  onDropAccepted={this.onDropImage}
                >
                  <p style={getStyle(screenSize, styles, 'dropZoneText')}>
                    {t('addImages')}
                  </p>
                </CBDropzone>
              </div>

              {/* Task creation hidden for chain messages — no vehicle-less tasks yet
              <CBLabelAndCheckbox
                color='blue'
                checked={formData.create_task}
                labelText={t('createTaskLabel', { ns: 'VehicleDetailsView' })}
                onChange={() => this.updateFormState({ target: 'create_task', value: !formData.create_task })}
                additionalStyles={{ marginBottom: 16 }}
              />
              */}

              <div style={getStyle(screenSize, styles, 'imagesContainer')}>
                {
                  !!newImages.length && (
                    newImages.map((image) => (
                      <ImagePreview
                        key={image.preview}
                        src={image.preview}
                        onDelete={() => this.deleteImage(image)}
                      />
                    ))
                  )
                }
              </div>
            </div>
          </CBModal>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0 32px 16px 32px',
    },
    formComponentContainer: {
      marginBottom: 16,
    },
    inputLabelText: {
      color: 'black',
    },
    input: {
      backgroundColor: '#ebebeb',
      fontSize: 14,
      textAlign: 'center',
      resize: 'none',
      color: 'black',
      borderRadius: 100,
      height: 40,
      border: 'none',
      width: '100%',
    },
    select: {
      backgroundColor: '#ebebeb',
      fontSize: 14,
      textAlign: 'center',
      resize: 'none',
      color: 'black',
      borderRadius: 100,
      height: 40,
      border: 'none',
      width: '100%',
      textAlignLast: 'center',
    },
    imagesContainer: {
      marginBottom: 16,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    roleNarrowingContainer: {
      marginTop: 8,
      padding: '8px 12px',
      backgroundColor: '#f5f5f5',
      borderRadius: 6,
      border: '1px solid #e0e0e0',
    },
    summaryContainer: {
      marginBottom: 16,
      padding: '10px 12px',
      backgroundColor: '#eaf3f8',
      borderLeft: '3px solid #0077b6',
      borderRadius: 4,
    },
    summaryText: {
      margin: 0,
      fontSize: 13,
      lineHeight: 1.45,
      color: '#1b3a4b',
    },
    summaryLabel: {
      fontFamily: 'TitilliumWeb-SemiBold',
      color: '#0077b6',
    },
    audienceHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
    },
    audienceCount: {
      flex: 1,
      fontSize: 12,
      color: '#1b3a4b',
    },
    audienceToggle: {
      background: 'none',
      border: 'none',
      color: '#0077b6',
      cursor: 'pointer',
      fontSize: 12,
      padding: 0,
    },
    audienceGroup: {
      marginTop: 6,
    },
    audienceGroupTitle: {
      fontSize: 12,
      fontFamily: 'TitilliumWeb-SemiBold',
      color: '#1b3a4b',
    },
    audienceUsers: {
      fontSize: 12,
      color: '#333',
      lineHeight: 1.4,
    },
    audienceWarning: {
      marginTop: 6,
      padding: '6px 8px',
      backgroundColor: '#fff3e0',
      borderLeft: '3px solid #e67e22',
      borderRadius: 4,
      fontSize: 12,
      color: '#7a3e00',
    },
    roleNarrowingRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 12,
      padding: '4px 0',
    },
    roleNarrowingLabel: {
      fontSize: 13,
      color: '#333',
      flex: 1,
    },
    roleNarrowingSelect: {
      backgroundColor: '#fff',
      fontSize: 13,
      color: '#333',
      borderRadius: 6,
      height: 32,
      border: '1px solid #ccc',
      width: 180,
    },
    dropZoneContainer: {
      marginBottom: 16,
    },
    dropZoneText: {
      color: 'rgb(102, 102, 102)',
      fontSize: 24,
    },
  },
  small: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '16px 16px',
    },
  },
};

function mapStateToProps(state) {
  return {
    user: state.authUser.user,
    selectedWorkshopId: state.workshop.selectedWorkshop,
    selectedChainId: state.chain.selectedChainId,
    chainMemberships: state.chain.chainMemberships,
    chainCareServices: state.chain.chainCareServices,
    chainCareServiceVehicles: state.chain.chainCareServiceVehicles,
    messageStatus: state.message.messageStatus,
    appService: state.app.service,
    selectedOrganizationId: state.organization.selectedOrganization
      && state.organization.selectedOrganization.id
      ? state.organization.selectedOrganization.id
      : state.organization.selectedOrganization,
  };
}

export default connect(
  mapStateToProps,
  {
    createChainMessage: _createChainMessage,
    createCSChainMessage: _createCSChainMessage,
    createChainVehicleMessage: _createChainVehicleMessage,
    fetchChainMemberships: _fetchChainMemberships,
    fetchChainCareServices: _fetchChainCareServices,
  },
)(translate('MessageListView')(CreateChainMessageModal));
